import { render, staticRenderFns } from "./Redo.vue?vue&type=template&id=bd60bdae&"
import script from "./Redo.vue?vue&type=script&lang=js&"
export * from "./Redo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports